import React from 'react'
import { useNavigate } from 'react-router-dom'
import Button from '../../Components/Button'
import GButton from '../../Components/GButton'
import Input from '../../Components/Input'
import QuizHeader from '../../Components/QuizHeader'
import styles from "./Styles/BasicDetails.module.css"
import sideImage from "../../Assets/basic_details.png"

export default function BasicDetails() {
  const navigate = useNavigate()
  return (
    <React.Fragment>
      <QuizHeader step1 />
      <div className={styles.container}>
        <main>
          <img className={styles.sideImage} src={sideImage} />

          <div className={styles.authForm}>
            <form>
                <h2>Start Your Journey</h2>
                <h3>Provide us with your basic details to proceed further.</h3>
                <Input white label="Full Name"  mb={24} type="username"/>
                <Input mb={24} white label="Email" type="email" />
                <Input white label="Phone Number" type="tel" />
                <Button height={56} onClickHandler={()=>navigate('/quiz/projectdetails')} radius={10} mt={32} title="Continue" />
            </form>
        </div>
        </main>
      </div>
    </React.Fragment>
  )
}
